import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
} from "@mui/material";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import {
  Operators,
  TextFilter,
} from "@progress/kendo-react-data-tools";
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import commonApiService from "../../../../shared/common-utilities/services/commonApiService";
import {postSavedView,fetchSavedView } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import { filterBy } from "@progress/kendo-data-query";
import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";

const ColumnPopUp = (props) => {
  const { gridSort, openModalColumnsSelect, setOpenModalColumnsSelect, gridTempColumnList, gridColumnList, savedViewTitle, gridFlagVal } = { ...props };

  const initialWidth = 400;
  const initialHeight = 500;
  let service = getSetDataService();
  let apiService = commonApiService();
  const userID = localStorage.getItem('userID');
  const [gridColumns, setGridColumns] = useState(gridColumnList);
  const [savedViewsApiData, setSavedViewsApiData] = useState([]);
  const [gridFilterFields, setGridFilterFields] = useState([]);
  const [dropdownHeight, setDropdownHeight] = useState(500);

  const [tempGridColumns, setTempGridColumns] = useState(
    gridTempColumnList
  );

  const initialSavedViewObj = { [gridFlagVal]: service.initialViewsObj };
  // let [colMultiFilter, setColMultiFilter] = React.useState({
  //   sortColumnsData: [],
  //   movTableColumns: gridColumns,
  //   draggedItem: {}
  // });

  let tempColumnsTitle = tempGridColumns && tempGridColumns.map((data) => data.title);

  let [selectedColumnsFields, setSelectedColumnsFields] = useState(tempColumnsTitle.slice());

  let [selectedColumns, setSelectedColumns] = useState({
    value: gridColumns && gridColumns.map((data) => data.title),
    allSelected: true,
  });

  const selectedColVal = selectedColumns?.value?.length;

  const [selectAllData, setSelectAllData] = useState(tempGridColumns.length == selectedColumns?.value?.length);

  const [initialCall, setInitialCall] = useState(true)

  const [isChecked, setIsChecked] = useState(false)
  const [position, setPosition] = useState({ left: 0, top:  0, width: initialWidth, height: initialHeight });
  const [visibleWindow, setVisibleWindow] = useState(false);

  useEffect(() => {
    let tempFieldList = [];
    tempGridColumns.forEach(e => {
      const obj = {
        name: e.field,
        label: e.title,
        filter: TextFilter,
        operators: Operators.text,
        type: e.type
      };
      tempFieldList.push(obj);
    });
    setGridFilterFields(tempFieldList);
    // fetchUpdateSavedViews(gridFlagVal, null);
    setVisibleWindow(true);
    service.setWindowInitialPosition(initialWidth, initialHeight, setPosition);
  }, [])

  const fetchUpdateSavedViews = (title, savedViewData) => {
    const filterUrl = (gridFlagVal !== "trip") ? `?$filter=(title eq '${title}' and userID eq '${userID}')` : null;
    const url = `${fetchSavedView}${filterUrl}`
    apiService.get(url).then(response => {
      if(response?.value?.length !== 0) {
        if (savedViewData === null) {
          setSavedViewsApiData(response.value);
        } else {
          apiService.put(response.value[0]["userMetadata@odata.mediaReadLink"], response.value[0]["@odata.etag"], savedViewData);
        }
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
  }

  const postSavedViewsData = async (title) => {
    return await apiService.post(postSavedView,{ userID: userID, title: title }).then(response => {
      return response;
    })
      .catch(error => {
        console.error('API error:', error);
      });
  }


  const colCheckboxItemRender = (li, itemProps) => {
    const numericTypeColList = gridColumns
      .filter((item) => item.type === "numeric")
      .map((data) => data.title);
    const styledColor = numericTypeColList.includes(itemProps.dataItem)
      ? "red"
      : null;
    const itemChildren = (
      <span style={{ color: styledColor }}>
        <input
          type="checkbox"
          name={itemProps.dataItem}
          checked={itemProps.selected}
          onChange={(e) => itemProps.onClick(itemProps.index, e)}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  const onColumnsCheckboxChange = (event) => {
    setSelectedColumns({ value: event.value });
  };

  const filterChange = (event) => { 
    setSelectedColumnsFields(filterBy(tempColumnsTitle.slice(), event.filter));
  };

  const closeColumnSelctorModal = () => {
    setOpenModalColumnsSelect(false);
  };

  const checkChanged = (e) => {
    setIsChecked(e.target.checked)
  }

  const saveColumnsSelectedData = () => {
    const views = localStorage.getItem(gridFlagVal + 'Savedview');
    const updatedColumn = views ? JSON.parse(views) : initialSavedViewObj;
    const filteredData = tempGridColumns.filter(item =>
      selectedColumns.value.includes(item.title)
    );
    // updatedColumn[gridFlagVal].columns = filteredData;

    localStorage.setItem(gridFlagVal + 'Savedview', JSON.stringify(updatedColumn));

    // if (gridFlagVal !== 'trip') {
    //   if (savedViewsApiData.length == 0) {
    //     postSavedViewsData(gridFlagVal).then(response => {
    //       fetchUpdateSavedViews(gridFlagVal, updatedColumn);
    //       setSavedViewsApiData(response);
    //     });
    //   } else {
    //     fetchUpdateSavedViews(gridFlagVal, updatedColumn);
    //   }
    // }
    // setGridColumns(filteredData);
    const filteredFields = [];
    filteredData.forEach(item => {
      if (!filteredFields.includes(item.field)) {
        filteredFields.push(item.field);
      }
    });
    const filteredSort = gridSort?.filter(item => filteredFields.includes(item.field));
    props.sendDataToParent(filteredSort, 'gridSort')
    props.sendDataToParent(filteredData, 'filteredData');
    setOpenModalColumnsSelect(false);
  };

  useEffect(() => {
    setGridColumns(gridColumnList);

    {
      (tempGridColumns.length != selectedColumns?.value?.length && initialCall == false) ?
      setSelectedColumns({
        value: tempGridColumns && tempGridColumns.map(item => item.title),
        allSelected: true
      }) : setSelectedColumns({
        value: [],
        allSelected: false
      })
    }
    // setColMultiFilter({
    //   ...colMultiFilter,
    //   movTableColumns: data.gridColumnList 
    // });
  }, [selectAllData])

  useEffect(() => {
    setGridColumns(gridColumnList);
    setInitialCall(true)

    {
      initialCall &&
      setSelectedColumns({
        value: gridColumnList && gridColumnList.map(item => item.title),
        allSelected: true
      })
    }
    // setColMultiFilter({
    //   ...colMultiFilter,
    //   movTableColumns: data.gridColumnList 
    // });
  }, [gridColumnList, openModalColumnsSelect])

  const onMoveWindow = (event) => {
    service.onMoveWindow(event, position, setPosition);
  };

  const onResizeWindow = (event) => {
    service.onResizeWindow(event, setPosition);
    setDropdownHeight(event.height);
  }

  return (
    <>
      {(openModalColumnsSelect && visibleWindow) && <Window 
        title={'Select Columns'}
        initialWidth={initialWidth}
        initialHeight={initialHeight} 
        minWidth={400} 
        minHeight={500} 
        onClose={closeColumnSelctorModal} 
        modal={true}
        className='kendo-popup'
        left={position.left} 
        top={position.top}
        onMove={onMoveWindow} 
        onResize={onResizeWindow}
        maximizeButton={() => { return null }} 
        doubleClickStageChange={false}
      >
        <Checkbox
          onClick={() => {
            setSelectAllData(!selectAllData);
            setInitialCall(false);
          }}
          onChange={checkChanged}
          sx={{m:0,p:0,mb:.3}}
          checked={(tempGridColumns.length == selectedColumns?.value?.length) ? true : false}
        /> {tempGridColumns.length == selectedColumns?.value?.length ? "De-Select All" : "Select All"} 
        <Box  >
          <MultiSelect
            data={selectedColumnsFields}
            itemRender={colCheckboxItemRender}
            autoClose={false}
            value={selectedColumns.value}
            onChange={onColumnsCheckboxChange}
            filterable={true}
            onFilterChange={filterChange}
            popupSettings={{ height: `${dropdownHeight - 170}px` }}
            tags={
              selectedColVal > 0
                ? [
                  {
                    text: `${selectedColVal} items selected`,
                    data: [...selectedColumns.value],
                  },
                ]
                : []
            }
          />
        </Box>
        <WindowActionsBar>
          <Button
            variant="contained"
            size="small"
            onClick={saveColumnsSelectedData}
          >
            Ok
          </Button>
        </WindowActionsBar>
      </Window>}
    </>
  );
};

export default ColumnPopUp;
